import { TokenResponse, TokenRequest } from '../../models/services/api/getAuthToken';
import { post } from './client';

export const getAuthToken = async (body: TokenRequest): Promise<TokenResponse> =>
  post<TokenResponse>('/v1/issue-token', body);
